// Icon system: one stroke, one weight, drawn in the label's print grammar.
const base = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: "false",
};

export const OrganiserIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="2.5" y="6.5" width="19" height="11" rx="2.5" />
    <path d="M8.8 6.5v11M15.2 6.5v11" />
    <path d="M4.5 9.5h2.3M10.9 9.5h2.2M17.3 9.5h2.2" />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
    <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    <path d="M7.5 13h2M11 13h2M14.5 13h2M7.5 16.5h2M11 16.5h2" />
  </svg>
);

export const GearIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M5.5 18.5l1.7-1.7M16.8 7.2l1.7-1.7" />
    <circle cx="12" cy="12" r="6.6" />
  </svg>
);

export const PrinterIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M7 8.5V4h10v4.5" />
    <rect x="3.5" y="8.5" width="17" height="8" rx="1.8" />
    <path d="M7 13.5h10v6.5H7z" />
    <path d="M17 11.5h.5" />
  </svg>
);

// iOS's own share glyph, in this system's stroke: on an iPhone Home Screen app
// the Print button opens the share sheet, so it wears the sheet's mark.
export const ShareIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 14.5V3.5M8.3 7.2L12 3.5l3.7 3.7" />
    <path d="M8.8 10H7a1.8 1.8 0 0 0-1.8 1.8v7.4A1.8 1.8 0 0 0 7 21h10a1.8 1.8 0 0 0 1.8-1.8v-7.4A1.8 1.8 0 0 0 17 10h-1.8" />
  </svg>
);

export const PlusIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 5.5v13M5.5 12h13" />
  </svg>
);

export const TrashIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4.5 7h15M9.5 7V4.5h5V7" />
    <path d="M6.5 7l1 13h9l1-13" />
    <path d="M10.2 10.5v6.5M13.8 10.5v6.5" />
  </svg>
);

export const ArrowUpIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 19V5M6 11l6-6 6 6" />
  </svg>
);

export const ArrowDownIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 5v14M6 13l6 6 6-6" />
  </svg>
);

export const CloseIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const CheckIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);
